import { useEffect } from "react";
import { useLocation } from "react-router";
import { analytics } from "../utils/rudderstack";

export const RudderStackTracker = () => {
  const location = useLocation();

  useEffect(() => {
    analytics.page();
  }, [location]);

  return null;
};
